import { render } from "./FloatingMessageWidget.vue?vue&type=template&id=72848378&scoped=true"
import script from "./FloatingMessageWidget.vue?vue&type=script&lang=js"
export * from "./FloatingMessageWidget.vue?vue&type=script&lang=js"

import "./FloatingMessageWidget.vue?vue&type=style&index=0&id=72848378&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72848378"]])

export default __exports__